import { AppVersionResult } from './app-version-result.model';

export class TokenResult {
  token: string;
  version: AppVersionResult;
}
